import React from "react";

import { cn } from "@/utils/utils";

const backspaceKey = "Backspace";

type InputProps = {
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBackspace: () => void;
  ariaLabel?: string;
  required?: boolean;
  onInvalid?: (e: any) => void;
};

export default function DigitInput({ ...props }: InputProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === backspaceKey) {
      props.onBackspace();
    }
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      id={props.id}
      aria-label={props.ariaLabel}
      name={props.id}
      value={props.value}
      placeholder=""
      className={cn("input-validator",
        "w-28 h-28 text-center text-base rounded-lg",
        "focus:outline-none bg-[var(--surface-default)] border-[1px] border-[var(--outline-default)]",
        "text-[var(--on-surface-default)]",
        "hover:bg-[var(--surface-hover)] hover:border-[var(--outline-default)]",
        "pressed:bg-[var(--surface-pressed)] pressed:border-[var(--outline-pressed)]"
      )}
      onChange={props.onChange}
      onKeyDown={handleKeyDown}
    />
  );
}